"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const UserAvatar_1 = __importDefault(require("../shared/UserAvatar"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const stateFunctions = __importStar(require("../../domain/stateFunctions"));
const stateFunctions_1 = require("../../domain/stateFunctions");
const users_1 = require("../../domain/model/users");
const ParticipantsTyping_1 = __importDefault(require("../shared/ParticipantsTyping"));
const ThemTyping_1 = __importDefault(require("../shared/ThemTyping"));
const BackButton_1 = __importDefault(require("../shared/BackButton"));
const GroupChatMenu_1 = __importDefault(require("./GroupChatMenu"));
const DefaultGroupChatIcon_1 = __importDefault(require("../shared/DefaultGroupChatIcon"));
const LastOnline_1 = __importDefault(require("./LastOnline"));
const changeSidePanel_1 = require("../../actions/app/changeSidePanel");
const panels_1 = require("../../domain/model/panels");
const DirectChatMenu_1 = __importDefault(require("./DirectChatMenu"));
exports.default = react_1.default.memo(Header);
const useStyles = makeStyles_1.default((theme) => ({
    titles: {
        color: theme.colors.header.primaryTextColor,
        lineHeight: "normal",
        paddingLeft: 18
    },
    subtitle: {
        color: theme.colors.header.secondaryTextColor,
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    closeButton: {
        color: colorManipulator_1.alpha(theme.colors.header.primaryTextColor, 0.6),
        marginLeft: -6,
        marginRight: 6,
    }
}));
function Header() {
    const dispatch = react_redux_1.useDispatch();
    const me = react_redux_1.useSelector((state) => state.usersState.me);
    const userDictionary = react_redux_1.useSelector((state) => state.usersState.userDictionary);
    const chat = react_redux_1.useSelector((state) => stateFunctions_1.getSelectedChat(state.chatsState));
    const leftPanelState = react_redux_1.useSelector((state) => state.appState.panelState.leftPanel);
    if (chat === null) {
        return react_1.default.createElement("div", null);
    }
    let icon;
    let chatName = "";
    let subTitle = null;
    let chatMenu = null;
    const any_unread = chatFunctions.getUnreadMessageCount(chat) > 0;
    if (chatFunctions.isDirectChat(chat)) {
        let muted = false;
        if (chatFunctions.isConfirmedChat(chat)) {
            muted = chat.muted;
        }
        chatMenu = react_1.default.createElement(DirectChatMenu_1.default, { chatId: chat.chatId, userId: chat.them, muted: muted, any_unread: any_unread });
        let imageId = null;
        let isOnline = false;
        if (userDictionary.hasOwnProperty(chat.them)) {
            const userSummary = userDictionary[chat.them];
            imageId = userSummary.imageId;
            chatName = userSummary.username;
            isOnline = users_1.isUserOnline(userSummary);
            subTitle = chatFunctions.isConfirmedChat(chat) && chat.themTyping
                ? react_1.default.createElement(ThemTyping_1.default, { variant: "caption" })
                : react_1.default.createElement(LastOnline_1.default, { variant: "caption", minutesSinceLastOnline: userSummary.minutesSinceLastOnline });
        }
        icon = react_1.default.createElement(UserAvatar_1.default, { userId: chat.them, imageId: imageId, isUserOnline: isOnline, size: "sm" });
    }
    else {
        icon = react_1.default.createElement(DefaultGroupChatIcon_1.default, { size: "sm" });
        chatName = chat.subject;
        if (chatFunctions.isConfirmedChat(chat) && me) {
            chatMenu = react_1.default.createElement(GroupChatMenu_1.default, { chatId: chat.chatId, muted: chat.muted, any_unread: any_unread });
            if (chat.participantsTyping.length) {
                const usernames = stateFunctions
                    .getUsers(chat.participantsTyping, userDictionary)
                    .map(u => u.username);
                subTitle = react_1.default.createElement(ParticipantsTyping_1.default, { usernames: usernames });
            }
            else {
                const participants = stateFunctions.getUsers(chat.participants, userDictionary);
                let text = "";
                if (participants.length > 5) {
                    const onlineCount = participants.filter(p => users_1.isUserOnline(p)).length;
                    text = `${chat.participants.length} members (${onlineCount + 1} online) `;
                }
                else {
                    const sortedParticipants = participants
                        .map(users_1.fromUserSummary)
                        .sort(users_1.compareUsersOnlineFirst);
                    text = sortedParticipants
                        .map(u => u.username)
                        .concat(["You"])
                        .join(", ");
                }
                subTitle =
                    react_1.default.createElement(Typography_1.default, { variant: "caption" },
                        react_1.default.createElement("span", { className: "text-link", onClick: () => (dispatch(changeSidePanel_1.changeRightPanel(panels_1.RightPanelType.Participants))) }, text));
            }
        }
    }
    const classes = useStyles();
    return (react_1.default.createElement(Grid_1.default, { component: "header", flexWrap: "nowrap", container: true, alignItems: "center" },
        leftPanelState === panels_1.LeftPanelType.None ?
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(BackButton_1.default, { onClick: () => history.back(), className: classes.closeButton })) : null,
        react_1.default.createElement(Grid_1.default, { item: true }, icon),
        react_1.default.createElement(Grid_1.default, { item: true, flexGrow: 1, overflow: "hidden" },
            react_1.default.createElement(Grid_1.default, { container: true, direction: "column", className: "header-titles " + classes.titles },
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(Typography_1.default, { variant: "body1" }, chatName)),
                react_1.default.createElement(Grid_1.default, { item: true, className: classes.subtitle, whiteSpace: "nowrap" }, subTitle))),
        chatMenu
            ? react_1.default.createElement(Grid_1.default, { item: true }, chatMenu)
            : null));
}
